import { render, staticRenderFns } from "./orgStructureIndex.vue?vue&type=template&id=86d27b06"
import script from "./orgStructureIndex.vue?vue&type=script&lang=js"
export * from "./orgStructureIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports